import ReservationConfirmation from '@/views/user/ReservationConfirmation.vue';
import Room from '@/views/user/Room.vue';
import RoomChooser from '@/views/user/RoomChooser.vue';
import Summary from '@/views/user/Summary.vue';
import YourPersonalData from '@/views/user/YourPersonalData.vue';
import YourReservations from '@/views/user/YourReservations.vue';
import { RouteRecordRaw } from 'vue-router';


export default [
  {
    path: '/',
    component: RoomChooser
  },
  {
    path: '/room/:id',
    component: Room
  },
  {
    path: '/your-reservations',
    component: YourReservations
  },
  {
    path: '/your-personal-data',
    component: YourPersonalData
  },
  {
    path: '/summary',
    component: Summary
  },
  {
    path: '/reservation-confirmation/:id',
    component: ReservationConfirmation
  },
  {
    path: '/:fallback(.*)*',
    redirect: '/'
  }
] as Array<RouteRecordRaw>;




